"use client"

import { useState } from "react"
import { FiStar, FiMessageSquare } from "react-icons/fi"

const RatingSystem = ({ moveId, onRatingSubmit }) => {
  const [rating, setRating] = useState(0)
  const [hoveredRating, setHoveredRating] = useState(0)
  const [comment, setComment] = useState("")
  const [submitted, setSubmitted] = useState(false)

  const handleSubmit = async () => {
    if (rating === 0) return

    try {
      // Simulate API call
      await new Promise((resolve) => setTimeout(resolve, 1000))

      setSubmitted(true)
      onRatingSubmit?.({ rating, comment })
    } catch (error) {
      console.error("Failed to submit rating:", error)
    }
  }

  if (submitted) {
    return (
      <div className="bg-gray-800 rounded-2xl shadow-xl border border-gray-700/50 overflow-hidden">
        <div className="p-6 text-center">
          <div className="w-16 h-16 bg-green-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <FiStar className="w-8 h-8 text-green-400" />
          </div>
          <h3 className="text-xl font-semibold text-white mb-2">Merci pour votre évaluation !</h3>
          <p className="text-gray-400">Votre avis nous aide à améliorer nos services.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-gray-800 rounded-2xl shadow-xl border border-gray-700/50 overflow-hidden">
      <div className="px-6 py-5 bg-gradient-to-r from-amber-500/10 to-amber-400/10 border-b border-gray-700/50">
        <div className="flex items-center gap-3">
          <FiStar className="w-5 h-5 text-amber-400" />
          <div className="text-lg font-semibold text-white">Évaluez votre expérience</div>
        </div>
      </div>

      <div className="p-6 space-y-6">
        {/* Star Rating */}
        <div className="text-center">
          <p className="text-gray-300 mb-4">Comment évaluez-vous ce déménagement ?</p>
          <div className="flex justify-center gap-2">
            {[1, 2, 3, 4, 5].map((star) => (
              <button
                key={star}
                onClick={() => setRating(star)}
                onMouseEnter={() => setHoveredRating(star)}
                onMouseLeave={() => setHoveredRating(0)}
                className="transition-all duration-200 hover:scale-110"
              >
                <FiStar
                  className={`w-8 h-8 ${
                    star <= (hoveredRating || rating) ? "text-amber-400 fill-current" : "text-gray-600"
                  }`}
                />
              </button>
            ))}
          </div>
          {rating > 0 && (
            <p className="text-amber-400 mt-2 font-medium">
              {rating === 1 && "Très insatisfait"}
              {rating === 2 && "Insatisfait"}
              {rating === 3 && "Correct"}
              {rating === 4 && "Satisfait"}
              {rating === 5 && "Très satisfait"}
            </p>
          )}
        </div>

        {/* Comment */}
        <div>
          <label className="block text-gray-300 font-medium mb-2">
            <FiMessageSquare className="w-4 h-4 inline mr-2" />
            Commentaire (optionnel)
          </label>
          <textarea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Partagez votre expérience..."
            rows={4}
            className="w-full px-4 py-3 bg-gray-700 text-white rounded-lg border border-gray-600 focus:border-amber-400 focus:outline-none resize-none"
          />
        </div>

        {/* Submit Button */}
        <button
          onClick={handleSubmit}
          disabled={rating === 0}
          className="w-full py-3 bg-amber-500 hover:bg-amber-600 disabled:bg-amber-500/50 text-white font-medium rounded-lg transition-colors flex items-center justify-center gap-2"
        >
          <FiStar className="w-4 h-4" />
          Soumettre l'évaluation
        </button>
      </div>
    </div>
  )
}

export default RatingSystem
